// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2uRuT","image":"Header_image__1XlFT","name":"Header_name__3FjG3","info":"Header_info__j6dA5","infoRow":"Header_infoRow__2eDZR"};